/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { breakpoints } from "../../../constants/mediaqueries";
import GroupByModal from "../../Helper/GroupByModal";
import { SearchInput } from "../../Helper/SearchInput";
import { ActiveFilterBadges } from "./ActiveFilterBadges";
import { DownloadExcelButton } from "./DownloadExcelButton";
import { useSwitchTabContext } from "./fields/useSwitchTab";
import { BulkLayerListCTAButton } from "./LayerListCta";
import StartCheckFromOverviewBulkButtons from "./StartCheckFromOverviewBulkButtons";
import TabSettings from "./TabSettings";

export default function TabActions() {
    const { groupByProps, setSearchQuery } = useSwitchTabContext();

    return (
        <div className="d-flex align-items-center gap-2 flex-wrap">
            <div className="d-flex align-items-center gap-2 flex-wrap flex-grow-1" css={css`margin-right: auto; @media (max-width: ${breakpoints[0]}px ) { order: 1; max-width: unset; margin-right: unset; }`}>
                <SearchInput placeholder="Search by label" onSearch={setSearchQuery} />
                {/* <FruitFilter />
                <FacilityFilter /> */}
                <ActiveFilterBadges />
            </div>

            <div className="d-flex align-items-center gap-2 flex-wrap" css={css`@media (max-width: ${breakpoints[0]}px ) { order: 0; margin-left: auto; }`}>
                <GroupByModal groupByProps={groupByProps} />
                <StartCheckFromOverviewBulkButtons />
                <BulkLayerListCTAButton />
                <TabSettings />
                <DownloadExcelButton />
            </div>
        </div>
    );
}
